const dynamicImportErrorPatterns = [
    /Failed to fetch dynamically imported module/i,
    /Importing a module script failed/i,
    /error loading dynamically imported module/i,
    /ChunkLoadError/i,
    /Loading chunk .* failed/i,
]

const getReloadStorageKey = () => `ki_guardian_dynamic_import_reload_${APP_VERSION}`

export const isDynamicImportLoadError = (error: unknown): boolean => {
    const message = error instanceof Error ? `${error.name} ${error.message}` : String(error || '')

    return dynamicImportErrorPatterns.some((pattern) => pattern.test(message))
}

export const reloadOnceOnDynamicImportLoadError = (error: unknown): boolean => {
    if (!isDynamicImportLoadError(error) || typeof window === 'undefined') {
        return false
    }

    const storageKey = getReloadStorageKey()
    const currentLocation = window.location.href

    if (window.sessionStorage.getItem(storageKey) === currentLocation) {
        return false
    }

    window.sessionStorage.setItem(storageKey, currentLocation)
    window.location.reload()

    return true
}

export const setupDynamicImportReloadHandler = (): void => {
    if (typeof window === 'undefined') {
        return
    }

    window.addEventListener('vite:preloadError', (event) => {
        event.preventDefault()
        reloadOnceOnDynamicImportLoadError(event.payload)
    })
}
